import BasicService from "./BasicService";

class RatingService extends BasicService {
    constructor() {
        super();
    }

    deleteRating(rating) {
        let url = `/rating/${rating.ratingId}`;
        return this.axios.delete(url, rating).then(request => request.data);
    }
    updateRating(rating) {
        let url = `/rating/${rating.ratingId}`;
        return this.axios.put(url, rating).then(request => request.data);
    }
    addRating(rating) {
        let url = `/rating`;
        return this.axios.post(url, rating).then(request => request.data);
    }
    getRating() {
        let url = "/rating";
        return this.axios
          .get(url)
          .then(response => response.data);
      }

      

}

const ratingService = new RatingService();
export default ratingService;